import script from "./batchButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./batchButton.vue?vue&type=script&setup=true&lang=ts"

import "./batchButton.vue?vue&type=style&index=0&id=10ecc5ea&lang=less"

const __exports__ = script;

export default __exports__